import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";

import { post } from "../../../helpers/api_helper";
import {
  capitalizeString,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_GetMachineConfigurationDetailByID,
  POST_MachineConfigurationInsert,
  POST_MachineConfigurationUpdate,
} from "../../../helpers/url_helper";

const AddMachineConfiguration = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    ProcessName: Yup.string().trim().required("Process is required field"),

    VendorRate: Yup.string().when("RateMatrix", ([RateMatrix], schema) => {
      if (RateMatrix == false)
        return Yup.string().required("Vendor Rate is required field");
      return schema;
    }),

    InvoiceRate: Yup.string().when("RateMatrix", ([RateMatrix], schema) => {
      if (RateMatrix == false)
        return Yup.string().required("Invoice Rate is required field");
      return schema;
    }),
  });

  const formik = useFormik({
    // validationSchema,
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MachiningConfigurationIDEncrypt: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      ProcessName: "",
      VendorRate: "",
      InvoiceRate: "",
      RateMatrix: false,
      ListOfThicknessLength: [],
      initialLengthList: {},
    },
    validateOnBlur: false,
  });

  const {
    values: {
      MachiningConfigurationIDEncrypt,
      VendorRate,
      InvoiceRate,
      RateMatrix,
      ListOfThicknessLength,
      initialLengthList,
      ProcessName,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (values?.RateMatrix == true) {
      if (
        values?.ListOfThicknessLength?.filter(
          (x) => x.Thickness?.trim() == "" && x.IsDelete == false
        )?.length > 0
      ) {
        warningMessage("Please fill all the Thickness fields...");
        return;
      }

      let errorThicknessStatus = false;
      values?.ListOfThicknessLength?.filter(
        (x) => x.IsDelete == false
      )?.forEach((item, i) => {
        if (
          values?.ListOfThicknessLength?.filter(
            (x) => x.IsDelete == false
          )?.filter(
            (x, ix) =>
              parseFloat(x.Thickness) == parseFloat(item.Thickness) && i !== ix
          )?.length > 0
        ) {
          errorThicknessStatus = true;
        }
      });

      if (errorThicknessStatus == true) {
        warningMessage("Duplicate Thickness fields...");
        return;
      }

      let errorLengthValueStatus = false;
      let errorLengthValueDuplicateStatus = false;
      let errorRateStatus = false;

      values?.ListOfThicknessLength?.filter(
        (x) => x.IsDelete == false
      )?.forEach((item, i) => {
        item?.ListOfLength?.forEach((para, iP) => {
          if (
            para?.RateList?.filter(
              (x) => x.LengthValue?.trim() == "" && x.IsDelete == false
            )?.length > 0
          ) {
            errorLengthValueStatus = true;
          }

          para?.RateList?.filter((x) => x.IsDelete == false)?.forEach(
            (range, iR) => {
              if (
                para?.RateList?.filter((x) => x.IsDelete == false)?.filter(
                  (x, ix) =>
                    parseFloat(x.LengthValue) ==
                      parseFloat(range.LengthValue) && iR !== ix
                )?.length > 0
              ) {
                errorLengthValueDuplicateStatus = true;
              }
            }
          );

          if (
            para?.RateList?.filter(
              (x) =>
                (x.VendorRate == "" || x.InvoiceRate == "") &&
                x.IsDelete == false
            )?.length > 0
          ) {
            errorRateStatus = true;
          }
        });
      });

      if (errorLengthValueStatus == true) {
        warningMessage("Please fill all the Length fields...");
        return;
      }

      if (errorLengthValueDuplicateStatus == true) {
        warningMessage("Duplicate Length fields...");
        return;
      }
      if (errorRateStatus == true) {
        warningMessage("Please fill all the Vendor - Invoice Rate  fields...");
        return;
      }
    }

    setIsLoading(true);

    let listOfPara = [];
    Promise.all((listOfPara = values?.ListOfThicknessLength));

    // Promise.all(
    //   values?.ListOfThicknessLength?.map((item) => {
    //     listOfPara = [
    //       ...listOfPara,
    //       {
    //         Thickness: item?.Thickness ? item?.Thickness : "0",
    //         IsDelete: item?.IsDelete,
    //         ListOfLength: item?.ListOfLength[0]?.map((p) => {
    //           let intiRateList = [];

    //           p?.RateList?.map((x) => {
    //             if (
    //               x.MachiningConfigurationRateMatrixIDEncrypt ||
    //               x.IsDelete == false
    //             ) {
    //               intiRateList = [
    //                 ...intiRateList,
    //                 {
    //                   MachiningConfigurationRateMatrixIDEncrypt:
    //                     x?.MachiningConfigurationRateMatrixIDEncrypt,
    //                   LengthValue: x?.LengthValue ? x?.LengthValue : "0",
    //                   VendorRate: x?.VendorRate ? x?.VendorRate : "0",
    //                   InvoiceRate: x?.InvoiceRate ? x?.InvoiceRate : "0",
    //                   IsDelete: x?.IsDelete,
    //                 },
    //               ];
    //             }
    //           });

    //           p.RateList = intiRateList;
    //         }),
    //       },
    //     ];
    //   })
    // );

    let payload = {
      ...values,
      ProcessName: values?.ProcessName ? values?.ProcessName?.trim() : "",
      VendorRate:
        values?.RateMatrix == false
          ? values?.VendorRate
            ? values?.VendorRate
            : "0"
          : "0",
      InvoiceRate:
        values?.RateMatrix == false
          ? values?.InvoiceRate
            ? values?.InvoiceRate
            : "0"
          : "0",

      ListOfThicknessLength: values?.RateMatrix == true ? listOfPara : [],
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    delete payload["initialLengthList"];
    //delete payload["ListOfThicknessLength"];

    console.log("payload: ", payload);
    //return;
    post(
      PrimaryIdParam
        ? POST_MachineConfigurationUpdate
        : POST_MachineConfigurationInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/machine-configuration-list");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (PrimaryIdParam) {
      getMachineConfigurationDetails();
    } else {
      formik.setFieldValue("ListOfThicknessLength", []);

      let initList = {
        Thickness: "",
        IsDelete: false,
        ListOfLength: [],
      };

      initList.ListOfLength = [
        ...initList.ListOfLength,
        {
          LengthValue: "",
          IsDelete: false,
          IsNew: false,
          RateList: [
            {
              LengthValue: "",
              VendorRate: "",
              InvoiceRate: "",
              IsDelete: false,
            },
          ],
        },
      ];

      formik.setFieldValue("ListOfThicknessLength", [initList]);
      formik.setFieldValue("initialLengthList", initList);
    }
  }, []);

  const getListOfThicknessLengthInti = (e) => {
    if (!PrimaryIdParam) {
      if (e?.target?.checked == true) {
        formik.setFieldValue("VendorRate", "");
        formik.setFieldValue("InvoiceRate", "");
      }
    }

    if (ListOfThicknessLength.length == 0) {
      formik.setFieldValue("ListOfThicknessLength", []);

      let initList = {
        Thickness: "",
        IsDelete: false,
        ListOfLength: [],
      };

      initList.ListOfLength = [
        ...initList.ListOfLength,
        {
          LengthValue: "",
          IsDelete: false,
          IsNew: false,
          RateList: [
            {
              LengthValue: "",
              VendorRate: "",
              InvoiceRate: "",
              IsDelete: false,
            },
          ],
        },
      ];

      formik.setFieldValue("ListOfThicknessLength", [initList]);
      formik.setFieldValue("initialLengthList", initList);
    }
  };

  const getMachineConfigurationDetails = () => {
    setIsLoading(true);
    post(POST_GetMachineConfigurationDetailByID, {
      MachiningConfigurationIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "MachineConfigurationIDEncrypt",
            response?.MachiningConfigurationIDEncrypt
          );
          formik.setFieldValue("ProcessName", response?.ProcessName);
          formik.setFieldValue("RateMatrix", response?.RateMatrix);
          formik.setFieldValue("VendorRate", response?.VendorRate);
          formik.setFieldValue("InvoiceRate", response?.InvoiceRate);

          formik.setFieldValue(
            "ListOfThicknessLength",
            response?.ListOfThicknessLength
          );

          let initList = {
            Thickness: "",
            IsDelete: false,
            ListOfLength: [],
          };

          response?.ListOfThicknessLength[0]?.ListOfLength?.map((item) => {
            initList.ListOfLength = [
              ...initList.ListOfLength,
              {
                LengthValue: "",
                IsDelete: false,
                IsNew: false,
                RateList: item?.RateList?.map((x) => {
                  return {
                    MachiningConfigurationRateMatrixIDEncrypt: "",
                    LengthValue: x.LengthValue,
                    VendorRate: "",
                    InvoiceRate: "",
                    IsDelete: false,
                  };
                }),
              },
            ];
          });
          formik.setFieldValue("initialLengthList", initList);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addNewLength = (i) => {
    let newInit = {
      ...initialLengthList,
      ListOfLength: initialLengthList?.ListOfLength?.map((e, idxP) => {
        if (i == idxP) {
          return {
            ...e,
            RateList: [
              ...e.RateList,
              {
                MachiningConfigurationRateMatrixIDEncrypt: "",
                LengthValue: "",
                VendorRate: "",
                InvoiceRate: "",
                IsDelete: false,
              },
            ],
          };
        } else {
          return { ...e };
        }
      }),
    };

    formik.setFieldValue("initialLengthList", newInit);

    let newList = ListOfThicknessLength?.map((item, idx) => {
      return {
        ...item,
        ListOfLength: item?.ListOfLength?.map((e, idxP) => {
          if (i == idxP) {
            return {
              ...e,
              RateList: [
                ...e.RateList,
                {
                  MachiningConfigurationRateMatrixIDEncrypt: "",
                  LengthValue: "",
                  VendorRate: "",
                  InvoiceRate: "",
                  IsDelete: false,
                },
              ],
            };
          } else {
            return { ...e };
          }
        }),
      };
    });
    formik.setFieldValue("ListOfThicknessLength", newList);
  };

  const removeLength = (i, iR) => {
    if (
      ListOfThicknessLength?.filter(
        (x) => x.IsDelete == false
      )[0]?.ListOfLength[0]?.RateList.filter((x) => x.IsDelete == false)
        ?.length > 1
    ) {
      let newInit = {
        ...initialLengthList,
        ListOfLength: initialLengthList?.ListOfLength?.map((e, idxP) => {
          if (i == idxP) {
            return {
              ...e,
              RateList: e.RateList?.map((r, idxR) => {
                if (iR == idxR) {
                  return { ...r, IsDelete: true };
                } else {
                  if (
                    e.RateList?.filter((x) => x.IsDelete == false)?.length > 1
                  ) {
                    return { ...r };
                  } else {
                    return { ...r, LengthValue: "" };
                  }
                }
              }),
            };
          } else {
            return { ...e };
          }
        }),
      };

      formik.setFieldValue("initialLengthList", newInit);

      let newList = ListOfThicknessLength?.map((item, idx) => {
        return {
          ...item,
          ListOfLength: item?.ListOfLength?.map((e, idxP) => {
            if (i == idxP) {
              return {
                ...e,

                RateList: e.RateList?.map((r, idxR) => {
                  if (iR == idxR) {
                    return { ...r, IsDelete: true };
                  } else {
                    if (
                      e.RateList?.filter((x) => x.IsDelete == false)?.length > 1
                    ) {
                      return { ...r };
                    } else {
                      return { ...r, LengthValue: "" };
                    }
                  }
                }),
              };
            } else {
              return { ...e };
            }
          }),
        };
      });

      formik.setFieldValue("ListOfThicknessLength", newList);
    } else {
      warningMessage("Atleast one Length is required");
    }
  };

  const addNewThickness = () => {
    formik.setFieldValue("ListOfThicknessLength", [
      ...ListOfThicknessLength,
      {
        ...initialLengthList,
        ListOfLength: initialLengthList?.ListOfLength?.map((e, idxP) => {
          return {
            ...e,
            RateList: e.RateList?.map((r, idxR) => {
              return {
                ...r,
                LengthValue:
                  ListOfThicknessLength[0].ListOfLength[idxP].RateList[idxR]
                    .LengthValue,
              };
            }),
          };
        }),
      },
    ]);
  };

  const removeThickness = (i) => {
    if (ListOfThicknessLength?.filter((x) => x.IsDelete == false)?.length < 2) {
      warningMessage("Atleast one Thickness is required");
    } else {
      let newList = ListOfThicknessLength?.map((item, idx) => {
        if (i == idx) {
          return {
            ...item,
            IsDelete: true,
            ListOfLength: item?.ListOfLength?.map((x) => {
              return {
                ...x,
                RateList: x.RateList?.map((r) => {
                  return { ...r, IsDelete: true };
                }),
              };
            }),
          };
        } else {
          return { ...item };
        }
      });
      formik.setFieldValue("ListOfThicknessLength", newList);
    }
  };

  const handleChangeLengthValue = (value, iPara, iRange) => {
    formik.setFieldValue(
      "ListOfThicknessLength",
      ListOfThicknessLength?.map((item, idx) => {
        return {
          ...item,
          ListOfLength: item?.ListOfLength?.map((e, idxP) => {
            if (iPara == idxP) {
              return {
                ...e,
                RateList: e.RateList?.map((r, idxR) => {
                  if (iRange == idxR) {
                    return {
                      ...r,
                      LengthValue: value,
                    };
                  } else {
                    return { ...r };
                  }
                }),
              };
            } else {
              return { ...e };
            }
          }),
        };
      })
    );
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Machining Configuration
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={4}>
                    <Field
                      label="Process"
                      name="ProcessName"
                      placeholder={"Enter Process"}
                      component={CustomInput}
                      required
                      maxLength={100}
                      autoFocus
                      onChange={(e) => {
                        formik.setFieldValue(
                          "ProcessName",
                          capitalizeString(e)
                        );
                      }}
                    />
                  </Col>
                  <Col lg={4}>
                    <label></label>
                    <div className="d-flex mb-2">
                      <label>Rate Matrix &nbsp;</label>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckChecked"
                          title={RateMatrix == true ? "Yes" : "No"}
                          checked={RateMatrix}
                          onChange={(e) => {
                            formik.setFieldValue("RateMatrix", !RateMatrix);
                            // if (RateMatrix) {
                            //   formik.setFieldValue("VendorRate", "");
                            //   formik.setFieldValue("InvoiceRate", "");
                            // }
                            getListOfThicknessLengthInti(e);
                          }}
                          style={{ cursor: "pointer" }}
                        ></input>
                      </div>
                    </div>
                  </Col>
                </Row>
                {RateMatrix == false ? (
                  <Row>
                    <Col lg={4}>
                      <Field
                        type="number"
                        label="Vendor Rate"
                        name="VendorRate"
                        placeholder={"Select Vendor Rate"}
                        component={CustomInput}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "VendorRate",
                            e?.target?.value ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        type="number"
                        label="Invoice Rate"
                        name="InvoiceRate"
                        placeholder={"Select Invoice Rate"}
                        component={CustomInput}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "InvoiceRate",
                            e?.target?.value ?? ""
                          );
                        }}
                      />
                    </Col>
                  </Row>
                ) : (
                  <>
                    <hr className="mt-1 mb-2"></hr>
                    <Row>
                      <Col lg={12}>
                        <div
                          id="ParameterCriteria-tbl_wrapper"
                          className="dataTables_wrapper table-responsive no-footer"
                        >
                          <table
                            id="ParameterCriteria-tbl"
                            className="table table-bordered no-footer mb-2"
                          >
                            <thead>
                              <tr key={0}>
                                <th
                                  rowSpan={3}
                                  style={{ minWidth: "30px" }}
                                ></th>
                                <th
                                  rowSpan={3}
                                  style={{
                                    minWidth: "150px",
                                  }}
                                  className="p-1"
                                >
                                  <div
                                    style={{
                                      textAlign: "right",
                                      width: "100%",
                                    }}
                                    className="mb-2 pe-1"
                                  >
                                    Length
                                  </div>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "middle",
                                      width: "100%",
                                    }}
                                  >
                                    Thickness
                                  </div>
                                </th>
                              </tr>

                              <tr key={1}>
                                {ListOfThicknessLength?.length > 0 &&
                                  ListOfThicknessLength?.filter(
                                    (x) => x.IsDelete == false
                                  )[0]?.ListOfLength?.map((item, i) =>
                                    item?.RateList?.map((x, ix) => (
                                      <th
                                        key={ix}
                                        colSpan={2}
                                        style={{
                                          padding: 1,
                                          display:
                                            x?.IsDelete == true ? "none" : "",
                                        }}
                                        className={
                                          item?.IsNew == true ? "newPara" : ""
                                        }
                                      >
                                        <div className="d-flex">
                                          <div style={{ width: "100%" }}>
                                            <Field
                                              type="number"
                                              name={`ListOfThicknessLength[0].ListOfLength[${i}].RateList[${ix}].LengthValue`}
                                              component={CustomInput}
                                              noMarginBottom={true}
                                              onChange={(e) => {
                                                formik.setFieldValue(
                                                  `ListOfThicknessLength[0].ListOfLength[${i}].RateList[${ix}].LengthValue`,
                                                  e?.target?.value ?? ""
                                                );

                                                handleChangeLengthValue(
                                                  e?.target?.value ?? "",
                                                  i,
                                                  ix
                                                );
                                              }}
                                            />
                                          </div>

                                          <div className="m-1 mt-2">
                                            {item?.RateList?.filter(
                                              (x) => x.IsDelete == false
                                            )?.length > 1 ? (
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md bg-danger-light me-1"
                                                title="Remove Length"
                                                onClick={(e) => {
                                                  removeLength(i, ix);
                                                  e.preventDefault();
                                                }}
                                              >
                                                <i className="fa fa-minus"></i>
                                              </Link>
                                            ) : (
                                              ""
                                            )}
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md bg-primary-light"
                                              title="New Length"
                                              onClick={(e) => {
                                                addNewLength(i);
                                                e.preventDefault();
                                              }}
                                            >
                                              <i className="fa fa-plus"></i>
                                            </Link>
                                          </div>
                                          {/* {ix == item?.RateList?.length - 1 ? (
                                            <div className="m-1 mt-2">
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md bg-primary-light"
                                                title="New Length"
                                                onClick={(e) => {
                                                  addNewLength(i);
                                                  e.preventDefault();
                                                }}
                                              >
                                                <i className="fa fa-plus"></i>
                                              </Link>
                                            </div>
                                          ) : (
                                            <div className="mt-2 ms-1 me-1">
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md bg-danger-light"
                                                title="Remove Length"
                                                onClick={(e) => {
                                                  removeLength(i, ix);
                                                  e.preventDefault();
                                                }}
                                              >
                                                <i className="fa fa-minus"></i>
                                              </Link>
                                            </div>
                                          )} */}
                                        </div>
                                      </th>
                                    ))
                                  )}
                              </tr>

                              <tr key={2}>
                                {ListOfThicknessLength?.length > 0 &&
                                  ListOfThicknessLength?.filter(
                                    (x) => x.IsDelete == false
                                  )[0]?.ListOfLength?.map((item, i) =>
                                    item?.RateList?.map((r, ir) => (
                                      <React.Fragment key={ir}>
                                        <th
                                          style={{
                                            textAlign: "center",
                                            padding: 1,
                                            minWidth: "90px",
                                            display:
                                              r?.IsDelete == true ? "none" : "",
                                          }}
                                          className={
                                            item?.IsNew == true ? "newPara" : ""
                                          }
                                        >
                                          Vendor Rate
                                        </th>
                                        <th
                                          style={{
                                            textAlign: "center",
                                            padding: 1,
                                            minWidth: "90px",
                                            display:
                                              r?.IsDelete == true ? "none" : "",
                                          }}
                                          className={
                                            item?.IsNew == true ? "newPara" : ""
                                          }
                                        >
                                          Invoice Rate
                                        </th>
                                      </React.Fragment>
                                    ))
                                  )}
                              </tr>
                            </thead>
                            <tbody>
                              {ListOfThicknessLength?.length > 0
                                ? ListOfThicknessLength?.map((item, i) => (
                                    <tr
                                      key={i}
                                      style={{
                                        display:
                                          item?.IsDelete == true ? "none" : "",
                                      }}
                                    >
                                      <td>
                                        <Link
                                          to="#"
                                          className="icon-box icon-box-md bg-primary-light"
                                          title="New Thickness"
                                          onClick={(e) => {
                                            addNewThickness();
                                            e.preventDefault();
                                          }}
                                        >
                                          <i className="fa fa-plus"></i>
                                        </Link>
                                        {ListOfThicknessLength?.filter(
                                          (x) => x.IsDelete == false
                                        )?.length > 1 ? (
                                          <Link
                                            to="#"
                                            className="icon-box icon-box-md bg-danger-light ms-1"
                                            title="Remove Thickness"
                                            onClick={(e) => {
                                              removeThickness(i);
                                              e.preventDefault();
                                            }}
                                          >
                                            <i className="fa fa-minus"></i>
                                          </Link>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td>
                                        <Field
                                          type="number"
                                          name={`ListOfThicknessLength[${i}].Thickness`}
                                          component={CustomInput}
                                          noMarginBottom={true}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              `ListOfThicknessLength[${i}].Thickness`,
                                              e?.target?.value ?? ""
                                            );
                                          }}
                                        />
                                      </td>
                                      {item?.ListOfLength?.map((para, ip) =>
                                        para?.RateList?.map((r, ir) => (
                                          <React.Fragment key={ir}>
                                            <td
                                              style={{
                                                display:
                                                  r?.IsDelete == true
                                                    ? "none"
                                                    : "",
                                              }}
                                              className={
                                                para?.IsNew == true
                                                  ? "newPara"
                                                  : ""
                                              }
                                            >
                                              <Field
                                                type="number"
                                                name={`ListOfThicknessLength[${i}].ListOfLength[${ip}].RateList[${ir}].VendorRate`}
                                                component={CustomInput}
                                                noMarginBottom={true}
                                                onChange={(e) => {
                                                  formik.setFieldValue(
                                                    `ListOfThicknessLength[${i}].ListOfLength[${ip}].RateList[${ir}].VendorRate`,
                                                    e?.target?.value ?? ""
                                                  );
                                                }}
                                              />
                                            </td>
                                            <td
                                              style={{
                                                display:
                                                  r?.IsDelete == true
                                                    ? "none"
                                                    : "",
                                              }}
                                              className={
                                                para?.IsNew == true
                                                  ? "newPara"
                                                  : ""
                                              }
                                            >
                                              <Field
                                                type="number"
                                                name={`ListOfThicknessLength[${i}].ListOfLength[${ip}].RateList[${ir}].InvoiceRate`}
                                                component={CustomInput}
                                                noMarginBottom={true}
                                                onChange={(e) => {
                                                  formik.setFieldValue(
                                                    `ListOfThicknessLength[${i}].ListOfLength[${ip}].RateList[${ir}].InvoiceRate`,
                                                    e?.target?.value ?? ""
                                                  );
                                                }}
                                              />
                                            </td>
                                          </React.Fragment>
                                        ))
                                      )}
                                    </tr>
                                  ))
                                : ""}
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger  btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AddMachineConfiguration;
